import { sendNewsLetterByEmail } from "./services/news-letter.service";
import { validateAndSendForm } from "./utils/form.util";

const rules = (inputs) => {
  const [emailInputNews] = inputs;
  return [
    {
      field: `${emailInputNews}`,
      rules: [
        {
          rule: "required",
          errorMessage: "El correo electrónico es obligatorio.",
        },
        {
          rule: "email",
          errorMessage: "Ingresa un correo electrónico válido.",
        },
      ],
    },
  ];
};

export const sendNewsForm = (form) => {
  validateAndSendForm(form, rules, sendNewsLetterByEmail, (wasSendForm) => {});
};
